<template>
    <div>
         <div class="row justify-content-center">
          <div class="col-md-7" 
            :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <!-- <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjs5" ></div> -->
            <br>
            <br>
            <br>
            <div style="height:100px;"></div>
            <p class=" text-3xl sm:text-5xl font-semibold text-center wow"
            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
             style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                Galery
            </p>
            <div class="p-1">
                <div class="bg-white p-1 rounded-lg  ml-1 sm:ml-0 border-2 border-oranger-400" style="border:3px solid orange;">
                    <div class="row justify-content-center" v-viewer>
                        <div class="col-6 mt-2 wow" 
                        :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                         v-for="(item, index) in $store.state.data.galery" :key="index+'gambar'">
                            <img src="https://lorempixel.com/640/480/people" class="img-fluid shadow rounded-lg" style="width:100%;height:100%;display:block;margin:auto;" alt="">
                        </div>
                    </div>
                </div>
            </div>
           <br>
            <br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import axios from "axios";
export default {
  data() {
    return {
     
    };
  },
  props:['particle'],
  mounted() {
        // window.particlesJS("particlesjs5", this.$store.state.particle)
  },
  components: {
  },
  methods: {
    
  },
};
</script>